<template lang="pug">
    div
        Tooltip(:content="$i18n.t(`rcmtable.openInPlayground`)" placement="top")
            Button(shape="circle" icon="ios-play" size="small" @click="openModal")
            Modal(
                v-model="showModal"
                :title="$i18n.t(`wafrules.wafRateLimitToken`)+' '+'Playground'"
                fullscreen
                :closable="false"
                )
                Form(label-position="left" :label-width="100")
                    FormItem(:label="$i18n.t(`wafrules.wafRate`)")
                        InputNumber(v-model="wafRate" :precision="0" :min="1" :max="10")
                        span  {{ $i18n.t(`wafrules.requestsPerSecond`) }}
                    FormItem(:label="$i18n.t(`wafrules.wafRateLimitToken`)")
                        div(v-for="(option, index) in options" :key="index" style="display: inline-flex;")
                            div(v-if="option.disabled" style="margin-right: 8px;")
                                div.wafRateLimitTokenContainer
                                    Icon.iconWithPrimaryColor(type="md-checkmark")
                                span {{ $i18n.t(`wafrules.wafRateLimitTokenLabel.${[option.value]}`) }}
                            template(v-else)
                                Checkbox(v-model="option.checked") {{ $i18n.t(`wafrules.wafRateLimitTokenLabel.${[option.value]}`) }}
                    FormItem(:label="$i18n.t(`wafrules.simulatedRequestsPerSecond`)")
                        Table(:columns="simulatedRequestsTableColumns" :data="wafRateLimitTokenCalculator" :max-height="275")
                    FormItem(:label="$i18n.t(`wafrules.wafRateLimitTokenCombinations`)" style="margin-bottom: 0")
                        Table(:columns="wafRateLimitTokenCombinationsTableColumns" :data="wafRateLimitTokenCombinationsTableData" :max-height="275")
                div(slot="footer")
                    Button(type="primary" @click="closeModal") {{ $i18n.t(`global.close`) }}
</template>
<script>
export default {
    name: "ExplainWafRateLimitToken",
    data() {
        return {
            showModal: this.$route.path === "/wafrules/rate-limit-token-playground",
            wafRate: 1,
            options: [
                { value: "group", disabled: true, checked: true },
                { value: "ruleName", disabled: true, checked: true },
                { value: "ip", disabled: false, checked: true },
                { value: "host", disabled: false, checked: true },
                { value: "uri", disabled: false, checked: false },
                { value: "method", disabled: false, checked: false },
                { value: "country", disabled: false, checked: false },
                { value: "ua", disabled: false, checked: false },
                // { value: "customSign", disabled: false, checked: false },
            ],
            simulatedRequests: [],
            wafRateLimitTokenCombinationsTableData: [],
        };
    },
    methods: {
        openModal() {
            this.showModal = true;
        },
        closeModal() {
            // 若直接透過路由 /wafrules/rate-limit-token-playground 開啟此 modal，可回到上一頁
            if (this.$route.path === "/wafrules/rate-limit-token-playground") {
                return this.$router.back(-1);
            }
            this.showModal = false;
        },
        generateSimulatedRequests() {
            const generateRandomRequestValue = (options) => options[Math.floor(Math.random() * options.length)];
            const generateRandomRequest = () => ({
                group: "my-group",
                ruleName: "my-waf",
                ip: generateRandomRequestValue(["1.1.1.1", "2.2.2.2"]),
                host: generateRandomRequestValue(["example01.com", "example02.com"]),
                uri: generateRandomRequestValue(["/", "/api"]),
                method: generateRandomRequestValue(["GET", "POST"]),
                country: generateRandomRequestValue(["TW", "CN"]),
                ua: generateRandomRequestValue(["curl/7.87.0", "Wget/1.21.3 (linux-gnu)"]),
            });
            this.simulatedRequests = Array.from({ length: 10 }, generateRandomRequest);
        },
    },
    computed: {
        simulatedRequestsTableColumns() {
            // 根據 this.options map 表頭
            let columns = this.options.map((option) => {
                return {
                    title: this.$i18n.t(`wafrules.wafRateLimitTokenLabel.${[option.value]}`),
                    key: option.value,
                    width: "150",
                };
            });
            // 額外加上預覽「請求速率令牌」的欄位
            columns.push({
                title: this.$i18n.t(`wafrules.wafRateLimitToken`),
                key: "wafRateLimitToken",
                width: "400",
                fixed: "right",
                render: (h, params) => {
                    return h(
                        "div",
                        { style: { display: "flex", "justify-content": "space-between", "align-items": "center" } },
                        [
                            h(
                                "div",
                                {
                                    style: {
                                        width: "250px",
                                    },
                                },
                                params.row.wafRateLimitToken
                            ),
                            h(
                                "Button",
                                {
                                    props: {
                                        type: params.row.hitCount > this.wafRate ? "error" : "default",
                                    },
                                    style: {
                                        cursor: "default",
                                    },
                                },
                                `${this.$i18n.t("wafrules.hit")} ${params.row.hitCount} ${this.$i18n.t(
                                    "wafrules.counts"
                                )} `
                            ),
                        ]
                    );
                },
            });
            return columns;
        },
        wafRateLimitTokenCalculator() {
            // 建立 Map 儲存 unique key(wafRateLimitToken)-value(hitCount) pair
            const wafRateLimitTokenMap = new Map();
            this.simulatedRequests = this.simulatedRequests.map((item) => {
                // 將 wafRateLimitToken map 到 this.simulatedRequests 裡
                const wafRateLimitToken = this.options
                    .map((option) => (option.checked ? item[option.value] : "-"))
                    .join(",");

                // 計算每一種 wafRateLimitToken 的命中次數，並 map 到 this.simulatedRequests 裡
                const hitCount = (wafRateLimitTokenMap.get(wafRateLimitToken) || 0) + 1; // 取得 key(item.wafRateLimitToken) 的 value。若無對應的 key，則從 0 開始累加。
                wafRateLimitTokenMap.set(wafRateLimitToken, hitCount); // 針對 key(item.wafRateLimitToken)，儲存更新的 value
                return { ...item, wafRateLimitToken, hitCount };
            });
            // 將 Map 轉成 Array
            this.wafRateLimitTokenCombinationsTableData = Array.from(
                wafRateLimitTokenMap,
                ([wafRateLimitToken, counts]) => ({ wafRateLimitToken, counts })
            );
            return this.simulatedRequests;
        },
        wafRateLimitTokenCombinationsTableColumns() {
            let columnKeys = ["wafRateLimitToken", "counts"];
            let columns = columnKeys.map((key) => {
                return {
                    title: this.$i18n.t(`wafrules.${key}`),
                    key: key,
                    width: "400",
                };
            });
            return columns;
        },
    },
    mounted() {
        this.generateSimulatedRequests();
    },
};
</script>
<style scoped>
    .wafRateLimitTokenContainer{
        display: inline-flex;
        width: 16px;
        align-items: center;
        justify-content: center;
        margin-right: 4px;
    }
</style>



// WEBPACK FOOTER //
// src/components/PoptipInfos/ExplainWafRateLimitToken.vue